import React from 'react'

const ErrorPage = () => {
    return (
        <div className="h-100 d-flex justify-content-center align-items-center">
            <p className='fs-3'>Page Not Found</p>
        </div>
    )
}

export default ErrorPage